export default {
  // SET Feed Report Data
  SET_FEED_REPORT_DATA(state, data) {
    state.feedReportData = data
  },
  
  // SET Loading States
  SET_LOADING_FEED_DATA(state, loading) {
    state.loadingFeedData = loading
  },
  
  SET_LOADING_QUEUES(state, loading) {
    state.loadingQueues = loading
  },
  
  SET_LOADING_USERS(state, loading) {
    state.loadingUsers = loading
  },
  
  // SET Error States
  SET_FEED_DATA_ERROR(state, error) {
    state.feedDataError = error
  },
  
  // SET Available Options
  SET_AVAILABLE_QUEUES(state, queues) {
    state.availableQueues = queues || []
  },
  
  SET_AVAILABLE_USERS(state, users) {
    state.availableUsers = users || []
  },
  
  // SET raw group users data for debugging
  SET_GROUP_USERS(state, groupUsers) {
    state.groupUsers = groupUsers || []
  },
  
  // SET Current Selections
  SET_SELECTED_QUEUES(state, queues) {
    state.selectedQueues = queues || []
  },
  
  SET_SELECTED_USERS(state, users) {
    state.selectedUsers = users || []
  },
  
  SET_SELECTED_DATE_RANGE(state, dateRange) {
    state.selectedDateRange = dateRange || []
  },
  
  SET_DATE_TYPE(state, dateType) {
    state.dateType = dateType || 'system'
  },
  
  // CLEAR States
  CLEAR_FEED_REPORT_DATA(state) {
    state.feedReportData = null
    state.feedDataError = null
  }
}